import { motion, prefersReducedMotion } from "@/lib/motion";

const orbs = [
  { size: 600, x: "10%", y: "20%", delay: 0, duration: 20, color: "primary" },
  { size: 400, x: "80%", y: "60%", delay: 2, duration: 25, color: "primary" },
  { size: 300, x: "60%", y: "10%", delay: 4, duration: 18, color: "accent" },
  { size: 500, x: "20%", y: "70%", delay: 1, duration: 22, color: "primary" },
  { size: 200, x: "90%", y: "20%", delay: 3, duration: 15, color: "accent" },
];

export const FloatingOrbs = () => {
  // Skip expensive blur animations for better performance
  if (prefersReducedMotion) {
    return (
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {orbs.map((orb, index) => (
          <div
            key={index}
            className="absolute rounded-full blur-[100px]"
            style={{
              width: orb.size,
              height: orb.size,
              left: orb.x,
              top: orb.y,
              background: `radial-gradient(circle, hsl(var(--${orb.color}) / 0.15) 0%, transparent 70%)`,
            }}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {orbs.map((orb, index) => (
        <motion.div
          key={index}
          className="absolute rounded-full blur-[100px] will-change-transform"
          style={{
            width: orb.size,
            height: orb.size,
            left: orb.x,
            top: orb.y,
            background: `radial-gradient(circle, hsl(var(--${orb.color}) / 0.15) 0%, transparent 70%)`,
          }}
          animate={{
            x: [0, 50, -30, 20, 0],
            y: [0, -40, 30, -20, 0],
            scale: [1, 1.1, 0.9, 1.05, 1],
          }}
          transition={{
            duration: orb.duration,
            delay: orb.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}
      
      {/* Animated gradient mesh */}
      <motion.div
        className="absolute inset-0 opacity-30"
        style={{
          background: `
            radial-gradient(ellipse 80% 50% at 20% 40%, hsl(var(--primary) / 0.2) 0%, transparent 50%),
            radial-gradient(ellipse 60% 40% at 80% 60%, hsl(174 72% 40% / 0.15) 0%, transparent 50%)
          `,
        }}
        animate={{
          opacity: [0.2, 0.35, 0.2],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
    </div>
  );
};
